import React from 'react';
import {
  TableFieldColumn,
  TableFieldCells,
  TableFieldCellProps,
} from '@eas/common-web';
import { DictionaryBoilerModel } from '../../models';

const BoilerTypesCell = ({
  rowValue,
  ...props
}: TableFieldCellProps<DictionaryBoilerModel>) => {
  const value = rowValue?.types?.map((type) => type.name)?.join(', ') ?? '';
  return (
    <TableFieldCells.TextCell {...props} rowValue={rowValue} value={value} />
  );
};

export function useBoilerModelsColumns(): TableFieldColumn<
  DictionaryBoilerModel
>[] {
  return [
    {
      name: 'Název',
      datakey: 'name',
      width: 300,
      CellComponent: TableFieldCells.TextCell,
    },
    {
      name: 'Aktivní',
      datakey: 'active',
      width: 100,
      CellComponent: TableFieldCells.BooleanCell,
    },
    {
      name: 'Značka kotle',
      datakey: 'brand.name',
      width: 200,
      CellComponent: TableFieldCells.TextCell,
    },
    {
      name: 'Typy kotle',
      datakey: 'types',
      width: 200,
      CellComponent: BoilerTypesCell,
    },
    {
      name: 'Platnost od',
      datakey: 'validFrom',
      width: 150,
      CellComponent: TableFieldCells.DateCell,
    },
    {
      name: 'Platnost do',
      datakey: 'validTo',
      width: 150,
      CellComponent: TableFieldCells.DateCell,
    },
    {
      name: 'Popis',
      datakey: 'description',
      width: 300,
      CellComponent: TableFieldCells.TextCell,
    },
  ];
}
